//@flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'

const ConditionalWrapper = ({ condition, wrapper, children }) => 
  condition ? wrapper(children) : children;

export class Person extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      imageSrc: null,
      isMobile: true,
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  setImageSource() {
    let imgSrc = null
    let fileName = this.props.name.replace(/[^a-zA-Z ]/g, "").replaceAll(' ', '-').toLowerCase()
    try {
      const trySrc = require('../../images/' + fileName + '.jpg')
      imgSrc = trySrc
    } catch (err) {
      console.log(
        '⚠ IMAGE NOT FOUND:',
        '.images/' + fileName + '.jpg'
      )
        imgSrc = require('./images/_dummy.jpg')
    }
    return imgSrc
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    }, function() {
      this.setState({
        imageSrc: this.setImageSource()
      })
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className={this.props.align ? 'person ' + this.props.align : 'person'}>
               <ConditionalWrapper
                  condition={this.state.isMobile}
                  wrapper={children => <TextWidth>{children}</TextWidth>}
                >
                  <div className="facts">
                    <div className='head'>
                        <img
                        src={this.state.imageSrc}
                      />
                    </div>
                  
                    <div className='info'>
                      <div className='info-wrapper'>
                        <h3 dangerouslySetInnerHTML={{__html: this.props.claim}}></h3>
                        
                        <div className='names'>
                          <h4>
                            {this.props.name}
                          </h4>
                          <div className='detail'>
                            {this.props.passion}
                          </div>
                        </div>
                      </div>

                  </div>
                </div>

                
                <div className='text' dangerouslySetInnerHTML={{__html: this.props.text}} />

            </ConditionalWrapper>
          </div>
  }
}



             